module.exports = __webpack_public_path__ + "static/media/img-111.4a4deb08.jpg";